/**
 * Mapear aquí todas las expresiones regulares de la aplicación:
 */

export const onlyNumbers = '^[0-9]*$';

/**
 * @description el separador del decimal es el punto (.)
 */
export const decimalNumber = '^[0-9]*\\.?[0-9]*$';

/**
 * @description El string debe contener:
 *  - Mínimo uno de los siguientes caracteres: @ $ ! % * # ? & ^ _ - 
 *  - Números y Letras (Mayúsculas y Minúsculas)</li>
 *  - Mínimo 6 caracteres </li>
 */
export const securePassword = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{6,}$/

/**
 * @description Correo electrónico: regla del estándar HTML (WHATWG) para `type="email"`,
 * pero exigiendo que el dominio termine en una extensión de al menos 2 letras (.pe, .com, .edu.pe...).
 * Así acepta correos personales, institucionales y peruanos, y rechaza `123@123` o `usuario@dominio`.
 */
export const emailRegEx = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;